import React from 'react';

type AttachmentsProps = {
  attachments: string[]
}

function Attachments({ attachments }: AttachmentsProps) {
  if (!attachments) return null;

  return (
    <div className="columns col-gapless">
      {
        attachments.map((url) => (
          <div key={url} className="column col-auto mr-1">
            <a href={url} target="_blank" rel="noreferrer">
              <img src={url.endsWith('.pdf') ? '/images/pdf-icon.png' : url} className="s-rounded" width={30} height={30} alt="Attachment" />
            </a>
          </div>
        ))
      }
    </div>
  );
}

export default Attachments;
